const mutations: any = {
  updateMapState (state: any, params: any) {
    state.zoom = params.zoom
    state.northeast = params.northeast
    state.southwest = params.southwest
  },
  updateMapStatus (state: any, params: any) {
    state.mapStatus = params
  }
}

export default mutations
